export const aiAgentAsyncDynamicPromptsAppGroupId = "/ai_agent/async_dynamic_prompts/:app_group_id";
